import styled from 'styled-components';

export default styled.div`
  padding: 24px 32px;
  border-radius: 12px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  gap: 24px 0;
  height: calc(-167px + 100vh);
  .middle-content {
    width: 1px;
    height: 100%;
    background-color: #e5e5e5;
    flex-shrink: 0;
  }
  .from-button-wrap {
    flex-shrink: 0;
    display: flex;
    gap: 24px;
  }
`;
